import { signalStore } from '@ngrx/signals';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { withAuthCore } from '@kikkz/shared/auth/data-access';
import { withB04OAuth } from './with-b04-oauth';

export const B04AuthStore = signalStore(withDevtools('auth'), withAuthCore(), withB04OAuth());
